import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonLoaderLegacyComponent } from '@mkp/shared/ui-library';

@Component({
  selector: 'mkp-cards-skeleton',
  imports: [SkeletonLoaderLegacyComponent],
  templateUrl: './product-cards-skeleton.component.html',
  styleUrl: './product-cards-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardsSkeletonComponent {}
